import { createAction, props } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";
import { PromptsDTO } from "src/app/models/Prompts/promptsDTO";

export const getPrompt = createAction(
  "[Prompts] Get a Prompt by code Action",
  props<{ code: string }>()
);
export const getPrompts = createAction(
  "[Prompts] Get All Prompts Action",
  props<{ options: any }>()
);
export const loadPrompts = createAction(
  "[Prompts] Load All Prompts Action",
  props<{ response: any[] }>()
);
export const getExcelPrompts = createAction(
  "[Prompts] Get All Prompts Excel Action",
  props<{ options: any }>()
);
export const loadExcelPrompts = createAction(
  "[Prompts] Load All Prompts Excel Action",
  props<{ response: any[] }>()
);
export const getDataTypePrompts = createAction(
  "[Prompts] Get All DataType Prompts Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadDataTypePrompts = createAction(
  "[Prompts] Load All DataType Prompts Action",
  props<{ response: any[] }>()
);
export const getCategoriesPrompts = createAction(
  "[Prompts] Get All Categories Prompts Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadCategoriesPrompts = createAction(
  "[Prompts] Load All Categoories Prompts Action",
  props<{ response: any[] }>()
);
// Table Configuration Settings
export const getPromptsTableConfig = createAction(
  "[Prompts] Get Prompts Table Configuration Action",
  props<{ options: any }>()
);
export const loadPromptsTableConfig = createAction(
  "[Prompts] Load Prompts Table Configuration Action",
  props<{ response: any[] }>()
);
export const savePromptsTableConfig = createAction(
  "[Prompts] Save Prompts Table Configuration Action",
  props<{ config: any }>()
);
export const updatePrompts = createAction(
  "[Prompts] Update Prompt Action",
  props<{ prompt: PromptsDTO }>()
);
export const createPrompts = createAction(
  "[Prompts] Create Prompt Action",
  props<{ prompt: PromptsDTO }>()
);
export const deletePrompts = createAction(
  "[Prompts] Delete Row Prompt Action ",
  props<{ promptCode: string }>()
);
export const setEnabled = createAction(
  "[Prompts] Set Prompt Enabled Action",
  props<{ data: PromptsDTO }>()
);
export const setDisabled = createAction(
  "[Prompts] Set Prompt Disabled Action",
  props<{ data: PromptsDTO }>()
);
export const setPrompt = createAction(
  "[Prompts] Set Prompt party Action",
  props<{ prompt: any }>()
);
export const resetPrompt = createAction("[Prompts] Reset Prompt party Action");
export const resetCreation = createAction("[Prompts] Reset Creation Action");
export const getLoadingState = createAction(
  "[Prompts] Get Prompt Loading State Action"
);

export const setLoadingStartState = createAction(
  "[Prompts] Set Prompt Loading Start State Action"
);
export const setLoadingEndState = createAction(
  "[Prompts] Set Prompt Loading End State Action"
);

export const resetPromptsState = createAction(
  "[Prompts] Reset Prompts State Action"
);
